import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Component } from 'react';

// Error boundary requires class component
// eslint-disable-next-line @repo/internal/react/no-class-components
export var RelayErrorBoundary = /*#__PURE__*/function (_Component) {
  function RelayErrorBoundary() {
    var _this;
    _classCallCheck(this, RelayErrorBoundary);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, RelayErrorBoundary, [].concat(args));
    _defineProperty(_this, "state", {
      hasError: false
    });
    return _this;
  }
  _inherits(RelayErrorBoundary, _Component);
  return _createClass(RelayErrorBoundary, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error) {
      // https://ecosystem-platform.atlassian.net/browse/UIM-2425
      // TODO: Catch relay errors and sent event outside our SLO
      // if (error?.message?.toLocaleLowerCase()?.includes('relay')) {
      // TODO: Add analytics event
      // return;
      // }

      // Rethrow error if not relay one
      throw error;
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.hasError) {
        return null;
      }
      return this.props.children;
    }
  }], [{
    key: "getDerivedStateFromError",
    value: function getDerivedStateFromError() {
      return {
        hasError: true
      };
    }
  }]);
}(Component);